import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { initialState } from './drivers.fixtures'
import { Driver } from './drivers.type'

export const driversSlice = createSlice({
  name: 'driversSlice',
  initialState,
  reducers: {
    setSelectedDriver: (state, action: PayloadAction<Driver>) => {
      state.selectedDriver = action.payload
    },
    clearSelectedDriver: (state) => {
      state.selectedDriver = initialState.selectedDriver
    },
  },
})

export const { setSelectedDriver, clearSelectedDriver } = driversSlice.actions

export default driversSlice.reducer
